
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.description
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'Travel podcast, india travel podcast, travel podcast india, Goan stories, time travel podcast, best travel podcast, travel podcast script'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.description
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.description
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Goa App'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/activities-meta-image.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/activities-meta-image.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/activities-meta-image.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Travel Podcast India: Goan stories - india travel podcast',
      description: 'Travel podcast, india travel podcast, travel podcast india, Goan stories, time travel podcast, best travel podcast, travel podcast script',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More on Goa App",
        "links": [
          {"sub_title":"Top Activities",
          "interLinks":[
          {
            "name":"Trending in Goa",
            "url":"/experiences/must-do-activities"
          },
          {
            "name":"Top Sellers Activities",
            "url":"/experiences/top-sellers"
          },
          {
            "name":"Romantic Couple Activities",
            "url":"/experiences/couple-friendly-activities"
          },
          {
            "name":"Watersports Activities",
            "url":"/experiences/outdoor-adventures-and-watersports"
          },
          {
            "name":"Couple photography",
            "url":"/experiences/goa-photoshoot-packages"
          }

          ]},
          {"sub_title":"Must-see popular attractions",
          "interLinks":[{
            "name":"Beaches in Goa",
            "url":"/goa/beaches"
          },
          {
            "name":"Nightlife in Goa",
            "url":"/goa/nightlife"
          },
          {
            "name":"Watersports in Goa",
            "url":"/goa/activities/category/water-sports"
          },
          {
            "name":"Heritage in Goa",
            "url":"/goa/religious-places"
          },
          {
            "name":"Restaurants in Goa",
            "url":"/restaurants"
          },
          {
            "name":"Casino in Goa",
            "url":"/goa/activities/category/entertainment"
          }
          ]},

          {"sub_title":"More on Goa App",
          "interLinks":[{
            "name":"Hire a Taxi",
            "url":"/taxi"
          },
          {
            "name":"Rent a Car",
            "url":"/rentals"
          },
          {
            "name":"Restaurants offers",
            "url":"/offers"
          },
          {
            "name":"Holiday Packages",
            "url":"/packages"
          },
          {
            "name":"Upcoming Events",
            "url":"/events"
          }


          ]}
        ]
      }
    };
  },
  jsonld() {
    if (!this.schemaData) {
      return null
    }
    return {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: this.schemaData.map((itm, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          "name": itm.post && itm.post.title ? itm.post.title : 'Goa App',
          "description": itm.post && itm.post.description ? itm.post.description :
            'activities in goa, water activities in goa, adventure activities in goa, sports activities in goa, water sports activities in goa, beach activities in goa, water sport activities in goa',
          "image": itm.post && itm.post.gallery && itm.post.gallery.length > 0 ? itm.post.gallery : [],
          "brand": {
            "@type": "Brand",
            "name": "Goa App"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "5",
            "ratingCount": "89",
            "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '5',
            "reviewCount": itm.post && itm.post.views ? String(itm.post.views.count).slice(0, 2) : '5',
          },
          "offers": {
            "@type": "Offer",
            "price": itm.seller ? this.activityDiscountPrice(itm.seller) : 0,
            "priceCurrency": "INR",
            "priceValidUntil": "2025-12-31",
            "availability": "InStock",
            "seller": {
              "@type": "Organization",
              "name": "Goa App"
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "IN",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 10,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/FreeReturn"
            },
            "shippingDetails": {
              "@type": "OfferShippingDetails",
              "deliveryTime": {
                "@type": "ShippingDeliveryTime",
                "businessDays": {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "https://schema.org/Monday",
                    "https://schema.org/Tuesday",
                    "https://schema.org/Wednesday",
                    "https://schema.org/Thursday",
                    "https://schema.org/Friday"
                  ]
                },
                "cutoffTime": "12:00:15Z",
                "handlingTime": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 2,
                  "unitCode": "d"
                },
                "transitTime": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 10,
                  "unitCode": "d"
                }
              },
              "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "INR"
              },
              "shippingDestination": [{
                "@type": "DefinedRegion",
                "addressCountry": "IN",
                "addressRegion": ["GA"]
              }]
            }
          },
        }
      })),
    };
  },

  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },
    
    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
